import React from 'react'

function TenderTextRectangular() {
    return (
        <embed src="\pdfs\EAT1.4.1_Q-R_Rectangular_displacement_outlet_kr.pdf" width="100%" height="2100px" />
    )
}

export default TenderTextRectangular